export function getLocalTimezone() {
  // eslint-disable-next-line new-cap
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
